import React from 'react';
import { Outlet } from 'react-router-dom';

const CompetitionPage = () => {

    return <Outlet/>

}


export default CompetitionPage